// 设备系统
export const DevOs = {
    ios: 'ios',
    android: 'android',
};
